import { Injectable } from '@angular/core';
import { LocalStorageService } from '@shared/utils/local-storage.service';
import {
  ProjectsServiceProxy,
  AddRemoveMemberToProjectInput,
  SetCurrentProjectToCacheInput,
} from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Injectable()
export class ProjectService {
  key: string = 'app.project.default-project-id';
  currentProjectKey: string = 'app.project.current-project'
  constructor(
    private _projectsService: ProjectsServiceProxy,
    private _localStorageService: LocalStorageService,
    private _sessionService: AppSessionService
  ) {}

  init(): void {
    this.getDefaultProject();
  }

  
  public async addMemberToProject(memberId: number) {
    if(!(this._sessionService.isAdmin || this._sessionService.isRoleProjectAdministration)){
      return;
    }
    const currentProjectId = await this.getCurrentProjectId()
    return await this._projectsService.addMemberToProject(new AddRemoveMemberToProjectInput({
        projectId: currentProjectId,
        memberId: memberId
    })).toPromise();
  }

  public async removeMemberFromProject(memberId: number) {
    const currentProjectId = await this.getCurrentProjectId()
    return this._projectsService.removeMemberFromProject(currentProjectId, memberId).toPromise();
  }
  
  
  public async getDefaultProjectId() {
    let projectId = await this.getDefaultProject();
    if (projectId) {
        return projectId;
      } else {
        if(this._sessionService.isRoleAdminOnly){
          return;
        }
        let project = await this._projectsService.getMyDefaultProject().toPromise();
        if(project && project.project){
            await this._localStorageService.setItemAsync(this.key, project.project)
            return project.project.id;
        }
    }
  }

  public async getCurrentOrDefaultProjectId(){
    let projectId = await this.getCurrentProjectId();

    if(!projectId){
      projectId = await this.getDefaultProjectId();
    }

    return projectId;
  }
  public async getCurrentProjectId() {
    var project = await this.getCurrentProject();
    if(project){
      return project.id;
    }
    return null;
  }

  public async setCurrentProjectToBackendCacheAsync(project){
    
    await this._projectsService.setCurrentProjectToCache(new SetCurrentProjectToCacheInput({
      id: project.id,
      name: project.name,
      status: project.status,
      keyContactId: project.keyContactId,
      isDefault: project.isDefault,
      allowiHub: project.allowiHub
    })).toPromise();
  }

  public async getCurrentProject() {
    const projectKey = `${this.currentProjectKey}-${this._sessionService.user.id}`;
    const project = await this._localStorageService
      .getItemAsync(projectKey)
      .then((project) => {
          return project;
      });
      return project;
  }

  public async setCurrentProjectAsync(project) {
    await this.setCurrentProjectToBackendCacheAsync(project)
    const projectKey = `${this.currentProjectKey}-${this._sessionService.user.id}`
    
    await this._localStorageService.setItemAsync(projectKey, project)
  }

  public async removeCurrentProjectAsync() {
    const projectKey = `${this.currentProjectKey}-${this._sessionService.user.id}`;
    
    await this._localStorageService.removeItemAsync(projectKey)
  }

  public async getMyProjects() {
    if(this._sessionService.tenantId){
      return await this._projectsService.getMyProjects().toPromise();
    }
  }

  private async getDefaultProject() {
    const projectId = await this._localStorageService
      .getItemAsync('app.project.default-project')
      .then((project) => {
        if (project) {
          return project.id;
        }
      });
      return projectId;
  }
  
}
